import { getBuilderFhirPatientByIdentifier } from '@ctw/shared/api/fhir/patient-helper';
import { SYSTEM_ZUS_UNIVERSAL_ID } from '@ctw/shared/api/fhir/system-urls';
import { useCtwQuery } from '@ctw/shared/hooks/use-ctw-query';
import { QUERY_KEY_UPID_PATIENT } from '@ctw/shared/utils/query-keys';

interface UseGetPatientByUpid {
  upid: string;
  enabled?: boolean;
}

export const useGetPatientByUpid = ({ upid, enabled = true }: UseGetPatientByUpid) =>
  useCtwQuery({
    queryId: QUERY_KEY_UPID_PATIENT,
    queryKey: [upid],
    queryFn: async ({ ctwFetch, requestContext }) =>
      getBuilderFhirPatientByIdentifier(ctwFetch, requestContext, upid, SYSTEM_ZUS_UNIVERSAL_ID),
    enabled,
  });
